import { type FC, type ReactElement, type ReactNode } from 'react'

import {
  Accordion,
  AccordionDetails,
  AccordionStack,
  AccordionSummary,
  Link,
} from 'base-ui'

import { useGlobalConfigContext } from '../../../../../global-config'
import { urlResolverGetRedeemPaperPrescription } from '../../../../../url-handling'
import { erxBonusLandingPageTextBreak } from '../../../../components/ErxBonusLandingPageTranslationValues'

import { ErxBonusLandingPageFaqDataV1 } from './ErxBonusLandingPageFaqData'

export const ErxBonusLandingPageFaqAccordionV1: FC = () => {
  const globalConfig = useGlobalConfigContext()
  const linkRedeemPaperPrescription = (text?: ReactNode[]): ReactElement => (
    <Link
      color="brand"
      href={urlResolverGetRedeemPaperPrescription(globalConfig)}
    >
      {text}
    </Link>
  )

  return (
    <AccordionStack>
      {ErxBonusLandingPageFaqDataV1.map(({ details, key, summary }) => (
        <Accordion
          itemProp="mainEntity"
          itemScope
          itemType="https://schema.org/Question"
          key={key}
        >
          <AccordionSummary itemProp="name">{summary}</AccordionSummary>
          <AccordionDetails
            className="prose"
            itemProp="acceptedAnswer"
            itemScope
            itemType="https://schema.org/Answer"
          >
            <div itemProp="text">
              {details({
                break: erxBonusLandingPageTextBreak,
                link: linkRedeemPaperPrescription,
              })}
            </div>
          </AccordionDetails>
        </Accordion>
      ))}
    </AccordionStack>
  )
}
